class Header {

  constructor() {
    this.headerMobileMenu();
    this.headerScroll();
  };

  /****************************************************************
   HEADER MOBILE MENU
  ****************************************************************/
  headerMobileMenu() {
    document.querySelector('.mobile-trigger').addEventListener('click', function (e) {
      if (document.querySelector('.mobile-container').classList.contains('engaged') == false) {
        document.querySelector('.mobile-container').classList.add('engaged');
      } else {
        document.querySelector('.mobile-container').classList.remove('engaged');
        document.querySelector('.mobile-container').classList.add('disengaging');
        window.setTimeout(function () {
          document.querySelector('.mobile-container').classList.remove('disengaging');
        }, 200);
      }
    });

    document.querySelector('.mobile-trigger > button').addEventListener('keypress', function (e) {
      if (e.keyCode == 13) {
        if (document.querySelector('.mobile-container').classList.contains('engaged') == false) {
          document.querySelector('.mobile-container').classList.remove('disengaged');
          document.querySelector('.mobile-container').classList.add('engaged');
        }
        else {
          document.querySelector('.mobile-container').classList.remove('engaged');
          document.querySelector('.mobile-container').classList.add('disengaging');
          window.setTimeout(function () {
            document.querySelector('.mobile-container').classList.remove('disengaging');
          }, 200);
        }
      }
    });
  };

  headerScroll() {
    let lastKnownScrollPosition = 0;
    let ticking = false;
    let header = document.querySelector('header.main');

    function updateScroll(scrollPos) {
      header.dataset.scroll = scrollPos;

      header.classList.toggle('header-scroll', scrollPos > 0);
    }

    document.addEventListener('scroll', (event) => {
      lastKnownScrollPosition = window.scrollY;
      if (!ticking) {
        setTimeout(() => {
          updateScroll(lastKnownScrollPosition);
          ticking = false;
        }, 20);

        ticking = true;
      }
    });
  };
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('header.main')) {
    const header = new Header();
  }

  // Search focus
  document.querySelector('.search-toggle')?.addEventListener('click', () => {
    setTimeout(() => {
      document.querySelector('#headerSearchTerm').focus();
    }, 200)
  });
})
